module.exports = __webpack_public_path__ + "static/assets/08c39886fbe34997f2f247229c114a1b.png";